import React from 'react';
import {message, Table, Tabs, Popconfirm, Button, Modal, Form, Select, Input, DatePicker} from 'antd';

const FormItem = Form.Item;
import moment from 'moment';
import request from '../utils/request';
import {dateConversion} from './index';

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {visible: false, record: {}};
        this.handleClick = this.handleClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleClick(e) {
        let {find} = this.props;
        (async (url) => {
            try {
                let response = await request(url);
                this.setState(Object.assign(this.state, {visible: true}, {record: response}))
            } catch (e) {
                console.log(e);
                message.error('查询此记录失败');
            }
        })(find)
    }

    handleCancel(e) {
        const {handleRefresh} = this.props;
        handleRefresh();
        this.props.form.resetFields();
        this.setState({visible: false})
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }
            Object.keys(values).forEach((key, index) => {
                if (typeof values[key] === "string") {
                    this.state.record[key] = values[key].trim();
                } else {
                    this.state.record[key] = values[key];
                }
                this.setState(this.state);
            });
            let record = this.state.record;
            const {handleRefresh, url} = this.props;
            (async (url) => {
                try {
                    let response = await request(url, 'post', record);
                    message.success('修改成功');
                    this.setState({visible: false});
                    handleRefresh();
                    this.props.form.resetFields();
                } catch (e) {
                    console.log(e);
                    message.error('修改失败');
                }
            })(url)
        });

    }

    render() {
        const record = this.state.record;
        let {metadata} = this.props;
        const {getFieldDecorator} = this.props.form;
        return (
            <span>
                <a type="primary" onClick={this.handleClick}>修改</a>
                <Modal
                    title="修改"
                    footer={null}
                    visible={this.state.visible}
                    maskClosable={false}
                    onCancel={this.handleCancel}
                >
                    <Form onSubmit={this.handleSubmit}>
                        {metadata.map((meta, index) => {
                            switch (meta.type) {
                                case 'Input':
                                    return <FormItem label={meta.label}>
                                        {getFieldDecorator(meta.field, {
                                            initialValue: record[meta.field],
                                            rules: [{
                                                required: meta.isRequired ? meta.isRequired : false,
                                                message: meta.label + '是必须的!'
                                            }],
                                        })(
                                            <Input
                                                key={index}
                                                addonBefore={meta.addonBefore}
                                                placeholder={meta.placeholder}/>)}
                                    </FormItem>;
                                case 'Select':
                                    return <FormItem label={meta.label}>
                                        {getFieldDecorator(meta.field, {
                                            initialValue: record[meta.field],
                                            rules: [{
                                                required: meta.isRequired ? meta.isRequired : false,
                                                message: meta.label + '是必须的!'
                                            }],
                                        })(
                                            <Select
                                                allowClear
                                                placeholder={meta.placeholder}>
                                                {meta.options.map((item, index) => {
                                                    return <Option key={index} value={
                                                        item.split("|").length > 1 ? item.split("|")[1] : item
                                                    }>{
                                                        item.split("|").length > 1 ? item.split("|")[0] : item
                                                    }</Option>
                                                })}
                                            </Select>)}
                                    </FormItem>;
                                case 'DatePicker':
                                    return <FormItem label={meta.label}>
                                        {getFieldDecorator(meta.field, {
                                            initialValue: moment(dateConversion(record[meta.field]), 'YYYY-MM-DD'),
                                            rules: [{
                                                type: 'object',
                                                required: meta.isRequired ? meta.isRequired : false,
                                                message: '请选择时间'
                                            }]
                                        })(
                                            <DatePicker/>)}
                                    </FormItem>;
                            }
                        })}
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form>
                </Modal>
            </span>
        );
    }
}

export default Form.create()(Edit);



// WEBPACK FOOTER //
// ./utils/edit.js